export { default } from './QuotationList' 


// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationList/index.js